import { Company } from '@/api/model/company'
import { Branch } from '@/api/model/branch'
import { BaseModel } from '@/api/base-model'
import { WebhookAPI } from '@/api/backend-client'
import { ReferralType } from '@/api/types'
import { Pipeline } from '@/api/model/pipeline'
import { Source } from '@/api/model/source'

export class Webhook extends BaseModel<Webhook> {
    protected collectionName = WebhookAPI.collectionName

    constructor(
        public company: Company|null,
        public id: string,
        public name: string,
        public referralType: ReferralType|null,
        public pipeline: Pipeline|null,
        public assignedToCompany: Company|null,
        public assignedToBranch: Branch|null,
        public status: string|null,
        public score: number = 0,
        public priority: boolean = false,
        public source: string|null,
        public newSource: Source|null,
        public additionalComment: string|null,
    ) { super(id) }

    get url() {
        return [
            process.env.VUE_APP_KEYVUE_BACKEND_BASEURL,
            process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH,
            '/service/active_campaign/referral?',
            new URLSearchParams({
                company: this.company.id,
                webhook: this.id,
            }).toString(),

        ].join('')
    }

    static fromData(data: any): Webhook {
        if (data === null || typeof data === 'string' || data instanceof Webhook) {
            return data
        }

        return new Webhook(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.name,
            data.referralType,
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.assignedToCompany ? Company.fromData(data.assignedToCompany) : null,
            data.assignedToBranch ? Branch.fromData(data.assignedToBranch) : null,
            data.status,
            data.score,
            data.priority,
            data.source,
            data.newSource ? Source.fromData(data.newSource) : null,
            data.additionalComment,
        )
    }
}
